import React, { useContext } from 'react';

export const SectionTitleInParentContext = React.createContext<boolean>(false);
export const SectionTitleInParentProvider = SectionTitleInParentContext.Provider;

export function useOptionalSectionTitles() {
  const titleInParent = useContext(SectionTitleInParentContext);
  return { titleInParent };
}
